import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ServerRepresentedEvent } from '@app/modules/events/models/event.model'
import { Workspace } from '@app/modules/workspaces/interfaces/workspace.interface'
import { environment } from '@environments/environment'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class EventMigrationService {
  constructor(private _http: HttpClient) {}

  /**
   * Migrates an event from one workspace to another
   * @param source_workspace_slug - The slug of the source workspace
   * @param target_workspace_slug - The slug of the target workspace
   * @param event_slug - The slug of the event to migrate
   * @returns Observable<{ message: string, status: number; event_id:number }>
   */
  migrateEvent(source_workspace_slug: string, target_workspace_slug: string, event_slug: string): Observable<{ message: string; status: number; event_id?: number }> {
    return this._http.post<{ message: string; status: number; event_id?: number }>(`${environment.planningApi}admin/workspace/clone-event`, {
      source_workspace_slug,
      target_workspace_slug,
      event_slug
    })
  }
}
